import type { AvatarColor, AvatarIllustration } from '~/constants/avatarCatalog';

import {
  DEFAULT_AVATAR_ILLUSTRATION,
  isValidColor,
  isValidIllustration,
} from '~/constants/avatarCatalog';

export const useUserAvatar = () => {
  const { user } = useAuth();

  const avatarIllustration = computed<AvatarIllustration>(() => {
    const stored = user.value?.avatarIllustration;
    return isValidIllustration(stored) ? stored : DEFAULT_AVATAR_ILLUSTRATION;
  });

  const avatarColor = computed<AvatarColor | null>(() => {
    const stored = user.value?.avatarColor;
    return isValidColor(stored) ? stored : null;
  });

  return { avatarIllustration, avatarColor };
};
